import { useMemo } from 'react'

import { RoomTypeForRateConnection } from '../../types/rateConnection'
import useStyles from './styles/RenderInputRowCell.styles'

interface RenderInputRowCellProps {
  roomTypeIndex: number
  ratePlanIndex: number
  channelIndex: number
  rateMultiplierIndex: number
  cellIndex: number
  updatedRateConnectionList: RoomTypeForRateConnection[]
  setUpdatedRateConnectionList: React.Dispatch<
    React.SetStateAction<RoomTypeForRateConnection[]>
  >
  weekendIndexes: number[]
}

const RenderInputRowCell: React.FC<RenderInputRowCellProps> = ({
  roomTypeIndex,
  ratePlanIndex,
  channelIndex,
  rateMultiplierIndex,
  cellIndex,
  updatedRateConnectionList,
  setUpdatedRateConnectionList,
  weekendIndexes
}) => {
  const classes = useStyles()

  const initialValue = useMemo(() => {
    return updatedRateConnectionList[roomTypeIndex].ratePlans[ratePlanIndex]
      .channels[channelIndex].rateMultipliers[rateMultiplierIndex]
      .dataForEachDate[cellIndex].rateMultiplierValue
  }, [])

  const handleChangeInputValue: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    const newValue = event.currentTarget.value

    setUpdatedRateConnectionList((prevList) => {
      return prevList.map((roomType, rtIndex) =>
        rtIndex === roomTypeIndex
          ? {
              ...roomType,
              ratePlans: roomType.ratePlans.map((ratePlan, rpIndex) =>
                rpIndex === ratePlanIndex
                  ? {
                      ...ratePlan,
                      channels: ratePlan.channels.map((channel, chIndex) =>
                        chIndex === channelIndex
                          ? {
                              ...channel,
                              rateMultipliers: channel.rateMultipliers.map(
                                (rateMultiplier, rmIndex) =>
                                  rmIndex === rateMultiplierIndex
                                    ? {
                                        ...rateMultiplier,
                                        dataForEachDate:
                                          rateMultiplier.dataForEachDate.map(
                                            (data, dataIndex) =>
                                              dataIndex === cellIndex
                                                ? {
                                                    ...data,
                                                    rateMultiplierValue:
                                                      newValue,
                                                    isChanged:
                                                      newValue !== initialValue
                                                  }
                                                : data
                                          )
                                      }
                                    : rateMultiplier
                              )
                            }
                          : channel
                      )
                    }
                  : ratePlan
              )
            }
          : roomType
      )
    })
  }

  const isChanged =
    updatedRateConnectionList[roomTypeIndex].ratePlans[ratePlanIndex].channels[
      channelIndex
    ].rateMultipliers[rateMultiplierIndex].dataForEachDate[cellIndex].isChanged

  return (
    <div
      className={[
        classes.dayContainer,
        classes.inputNoSpinner,
        weekendIndexes?.includes(cellIndex % 7)
          ? classes.weekendDayContainer
          : '',
        isChanged ? classes.editedDayContainer : ''
      ].join(' ')}>
      <div>
        {
          <input
            value={
              updatedRateConnectionList[roomTypeIndex].ratePlans[ratePlanIndex]
                .channels[channelIndex].rateMultipliers[rateMultiplierIndex]
                .dataForEachDate[cellIndex].rateMultiplierValue
            }
            onChange={handleChangeInputValue}
            type="number"
          />
        }
      </div>
    </div>
  )
}

export default RenderInputRowCell
